import { Key, MouseEventHandler, PropsWithChildren, useEffect, useRef, useState } from 'react'
import { FoundationsAccordionType } from '../Types/FoundationsTypes'

function AccordionItem(props: FoundationsAccordionType) {
    const {
        id,
        accordionHeader,
        accordionStringContent,
        headerClasses,
        contentClasses,
        open,
        onClick,
        customIcon,
    } = props
    const contentHeight = useRef<HTMLDivElement>(null)
    const [singleOpen, setSingleOpen] = useState(!!open)
    const [height, setHeight] = useState("auto")
   
    useEffect(() => {
        if (contentHeight.current) {
          setHeight(""+contentHeight.current?.scrollHeight+"px")
        }
    }, []); 

    return (
        <div id={id} className="accordion-wrapper">
            <button
                className={`accordion-header-container ${(onClick ? open : singleOpen) ? 'active' : ''} ${headerClasses ? headerClasses : ''}`}
                onClick={
                    onClick
                        ? onClick
                        : () => {
                              setSingleOpen(!singleOpen)
                          }
                }
            >
                <p className="accordion-header-content">{accordionHeader}</p>
                <span
                    className={`accordion-icon ${customIcon ? customIcon : 'feather icon-chevron-down'} ${(onClick ? open : singleOpen) ? 'active' : ''}`}
                />
            </button>
            <div
                ref={contentHeight}
                className={`accordion-content-container ${contentClasses ? contentClasses : ''}`}
                style={
                    (onClick ? open : singleOpen) 
                        ? { height: height } 
                        : { height: '0px' }
                }
            >
                {accordionStringContent !== undefined ?  <p className="accordion-content">{accordionStringContent}</p> : <></>}
                {props.children !== undefined ? props.children : <></>}
            </div>
        </div>
    )
}

function Accordion({
    id,
    data,
    headerClasses,
    contentClasses,
    onToggle,
}: {
    id: string,
    data: { accordionHeader: string; accordionContent: string }[]
    headerClasses: string
    contentClasses: string
    onToggle?: (isOpen: boolean) => void;
}) {
    const [activeIndex, setActiveIndex] = useState(-1)

    const handleItemClick = (index: number) => {
        const isOpen = activeIndex === index ? false : true;
        setActiveIndex(isOpen ? index : -1);
        onToggle?.(isOpen); //FP-10590 : onToggle for updating accordionHeader
    };

    return (
        <div className="accordion-container">
            {data.map(
                (item: { accordionHeader: string; accordionContent: string }, index: number) => (
                    <>
                        <AccordionItem
                            id={`accordion_${id}_${index}`}
                            key={index}
                            accordionHeader={item.accordionHeader}
                            accordionStringContent={item.accordionContent}
                            headerClasses={headerClasses}
                            contentClasses={contentClasses}
                            open={activeIndex === index}
                            onClick={() => handleItemClick(index)}
                        />
                    </>
                )
            )}
        </div>
    )
}

export { AccordionItem, Accordion }
